import { DateTime } from 'luxon';

const setNotesState = (currentNotes, newState) => currentNotes.map((note) => {
  const newNote = { ...note };
  newNote.state = newState;
  return newNote;
});

export const SET_INITIAL_STATE = 'set-initial-state';
export const UPDATE_NOTE_TIMERS = 'update-note-timers';
export const PAUSE_ALL_NOTES = 'pause-all-notes';
export const RESTART_LAST_ACTIVE = 'restart-last-active';
export const REMOVE_ALL_NOTES = 'remove-all-notes';
export const REMOVE_NOTE = 'remove-note';
export const TITLE_CHANGE = 'title-change';
export const EDITOR_CHANGE = 'editor-change';
export const STATE_CHANGE = 'state-change';
export const ADD_NOTE = 'add-note';
export const ADJUST_TIME = 'adjust-time';
export const RESET_NOTE_TIME = 'reset-note-time';
export const COPY_NOTE = 'copy-note';

const homePageReducer = (state, action) => {
  switch (action.type) {
    case ADD_NOTE: {
      const newNote = {
        id: DateTime.utc().toMillis(),
        elapsed: 0,
        title: '',
        editorContent: '',
        state: 0,
      };

      return { ...state, notes: [...state.notes, newNote] };
    }
    case STATE_CHANGE: {
      let currentNotes = [...state.notes];
      let isActive = { ...state.isActive };
      if (action.timerState === 0) {
        isActive = 0;
        currentNotes = setNotesState(currentNotes, 0);
      }
      const noteIndex = currentNotes.findIndex((note) => note.id === action.key);
      const updateNote = currentNotes[noteIndex];

      if (updateNote.state === 0) {
        isActive = 1;
        updateNote.state = 1;
      } else {
        isActive = 0;
        updateNote.state = 0;
      }

      currentNotes[noteIndex] = updateNote;

      return {
        ...state, isActive, lastActive: action.key, notes: [...currentNotes],
      };
    }
    case EDITOR_CHANGE:
    {
      const currentNotes = [...state.notes];
      const noteIndex = currentNotes.findIndex((note) => note.id === action.key);
      const updateNote = currentNotes[noteIndex];
      if (updateNote) {
        updateNote.editorContent = action.editorState;
        currentNotes[noteIndex] = updateNote;
      }
      return { ...state, notes: [...currentNotes] };
    }
    case TITLE_CHANGE:
    {
      const currentNotes = [...state.notes];
      const noteIndex = currentNotes.findIndex((note) => note.id === action.key);
      const updateNote = currentNotes[noteIndex];
      updateNote.title = action.title;
      currentNotes[noteIndex] = updateNote;

      return { ...state, notes: [...currentNotes] };
    }
    case REMOVE_NOTE:
    {
      const currentNotes = [...state.notes];
      let { isActive, lastActive, totalTime } = state;
      const noteIndex = currentNotes.findIndex((note) => note.id === action.key);
      const deleteNote = currentNotes[noteIndex];
      if (deleteNote.state === 1) {
        isActive = 0;
      }
      currentNotes.splice(noteIndex, 1);
      if (currentNotes.length === 0) {
        isActive = 0;
      }
      if (lastActive === action.key) {
        lastActive = null;
      }
      totalTime -= deleteNote.elapsed;
      return {
        ...state, isActive, lastActive, notes: [...currentNotes], totalTime,
      };
    }
    case REMOVE_ALL_NOTES:
    {
      return {
        ...state, isActive: 0, lastActive: null, notes: [], totalTime: 0,
      };
    }
    case PAUSE_ALL_NOTES:
    {
      const pausedNotes = setNotesState([...state.notes], 0);
      return { ...state, isActive: 0, notes: [...pausedNotes] };
    }
    case RESTART_LAST_ACTIVE:
    {
      const currentNotes = [...state.notes];
      const { lastActive } = state;
      let { isActive } = state;

      if (lastActive !== null) {
        const noteIndex = currentNotes.findIndex((note) => note.id === lastActive);
        const updateNote = currentNotes[noteIndex];
        updateNote.state = 1;
        currentNotes[noteIndex] = updateNote;
        isActive = 1;
      }

      return { ...state, isActive, notes: [...currentNotes] };
    }
    case UPDATE_NOTE_TIMERS:
    {
      const currentNotes = [...state.notes];
      let { totalTime } = state;
      const noteIndex = currentNotes.findIndex((note) => note.state === 1);
      const updateNote = currentNotes[noteIndex];
      if (updateNote) {
        updateNote.elapsed += action.time;
        totalTime += action.time;
        currentNotes[noteIndex] = updateNote;
      }

      return { ...state, notes: [...currentNotes], totalTime };
    }

    case ADJUST_TIME:
    {
      const currentNotes = [...state.notes];
      let { totalTime } = state;
      const noteIndex = currentNotes.findIndex((note) => note.id === action.key);
      const updateNote = currentNotes[noteIndex];
      totalTime -= updateNote.elapsed;
      updateNote.elapsed += action.seconds;
      if (updateNote.elapsed < 0) {
        updateNote.elapsed = 0;
      }
      totalTime += updateNote.elapsed;
      currentNotes[noteIndex] = updateNote;
      return { ...state, notes: [...currentNotes], totalTime };
    }

    case SET_INITIAL_STATE: {
      return action.data ? action.data : state;
    }
    case RESET_NOTE_TIME: {
      const currentNotes = [...state.notes];
      let { totalTime } = state;
      const noteIndex = currentNotes.findIndex((note) => note.id === action.key);
      const updateNote = currentNotes[noteIndex];
      totalTime -= updateNote.elapsed;
      updateNote.elapsed = 0;
      currentNotes[noteIndex] = updateNote;
      return { ...state, notes: [...currentNotes], totalTime: (totalTime > 0) ? totalTime : 0 };
    }
    case COPY_NOTE: {
      const currentNotes = [...state.notes];
      let { totalTime } = state;
      const noteIndex = currentNotes.findIndex((note) => note.id === action.key);
      const sourceNote = { ...currentNotes[noteIndex] };
      sourceNote.state = 0;
      sourceNote.id = DateTime.utc().toMillis();
      totalTime += sourceNote.elapsed;
      currentNotes.splice((noteIndex + 1), 0, sourceNote);
      return { ...state, notes: [...currentNotes], totalTime };
    }

    default:
      return state;
  }
};

export { homePageReducer };
